import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseModel } from '../shared/models/base-model';

@Injectable({
  providedIn: 'root'
})
export class BlogService {
  apiUrl: string
  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}/blogs`
  }

  getAllBlogs() {
    return this.http.get<any>(`${this.apiUrl}/all`)
    .pipe(
      catchError(this.handleError),
      map(res => {
        return this.handleBaseResponse(res)
    }))
  }

  searchBlogs(params) {
    return this.http.post<any>(`${this.apiUrl}/search_blogs`, params)
    .pipe(
      catchError(this.handleError),
      map(res => {
        return this.handleBaseResponse(res)
    }))
  }

  getBlogBySlug(params) {
    return this.http.get<any>(`${this.apiUrl}/get_blog_by_slug?slug=${params.slug}`)
    .pipe(
      catchError(this.handleError),
      map(res => {
        return this.handleBaseResponse(res)
    }))
  }

  getBlog(params) {
    return this.http.get<any>(`${this.apiUrl}/get_blog_by_id?id=${params.id}`)
    .pipe(
      catchError(this.handleError),
      map(res => {
        return this.handleBaseResponse(res)
    }))
  }

  private handleBaseResponse(res: BaseModel) {
    if (res.success) {
      return res.payload
    } else {
      throwError(res.errors)
      return res
    }
  }

  private handleError(error) {
    let errorMessage = ''
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.errors}`
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error['error']['errors']}`
    }
    return throwError({status: error.status, msg: errorMessage})
  }


}
